import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const TruncateLinesWrapper = styled('span')`
  display: -webkit-box;
  overflow: hidden;

  -webkit-box-orient: vertical;

  ${(props: { $lines?: number; $lineHeight: number }) => {
    const { $lines: lines = 1, $lineHeight: lineHeight = 1.5 } = props

    return `
      -webkit-line-clamp: ${lines};
      line-height: ${lineHeight}rem;
      max-height: ${lineHeight * (lines + 1)}rem;
    `
  }}
  white-space: normal;
`

export const CssTruncation = styled(Box)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
